import { FC, ReactNode } from 'react'

import { Box } from '@mui/material'
import { CORAL_600 } from 'constants/styling/theme'

interface Props {
  /** Circle size: sm (4.8rem) for plan cards, md (5.6rem) for plan summary */
  size: 'sm' | 'md'
  /** Icon element to render inside the circle */
  children: ReactNode
}

const SIZE_MAP = {
  sm: { outer: '4.8rem', icon: '1.8rem' },
  md: { outer: '5.6rem', icon: '2rem' },
}

export const PlanIconCircle: FC<Props> = ({ size, children }) => {
  const { outer, icon } = SIZE_MAP[size]

  return (
    <Box
      sx={{
        width: outer,
        height: outer,
        minWidth: outer,
        borderRadius: '10rem',
        background: 'linear-gradient(180deg, #FCF0ED 0%, rgba(252, 240, 237, 0.00) 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          width: `calc(${outer} - 1.6rem)`,
          height: `calc(${outer} - 1.6rem)`,
          borderRadius: '50%',
          background: 'linear-gradient(181deg, #FAE4DE 0.76%, rgba(250, 228, 222, 0.00) 80.8%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '& svg': { color: CORAL_600, fontSize: icon },
        }}
      >
        {children}
      </Box>
    </Box>
  )
}
